<template>
  <div class="row">
    <div class="col-md-12">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <font-awesome-icon icon="map-marker-alt"
                               :class="{'text-success': hasValidCoordinates}"
            />
          </span>
        </div>
        <input type="text"
               ref="autocomplete"
               class="form-control"
               :class="{'loading-gif': loading}"
               :placeholder="placeholder"
               v-model="autocomplete"
        >
      </div>
    </div>
    <transition name="slide">
      <div class="col-md-12 address-components"
           v-show="showAddressComponents"
           ref="addressComponents"
      >
        <div class="row no-gutters pt-1 pr-2 pl-2 pt-2">
          <div class="col-5 pr-1">
            <input type="text" class="form-control form-control-sm geo-input"
                   :placeholder="$t('Street')"
                   v-model="address.streetName"
            >
          </div>
          <div class="col-4 pr-1">
            <input type="text" class="form-control form-control-sm geo-input"
                   :placeholder="$t('House number')"
                   name="streetHouseNumber"
                   v-model="address.streetHouseNumber"
            >
          </div>
          <div class="col-3">
            <input type="text" class="form-control form-control-sm"
                   :placeholder="$t('House number addition')"
                   name="streetHouseNumberAddition"
                   v-model="address.streetHouseNumberAddition"
            >
          </div>
        </div>
        <div class="row no-gutters pt-1 pr-2 pl-2 pb-2">
          <div class="col-2 pr-1">
            <select class="form-control form-control-sm"
                    v-model="address.countryCode">
              <option value="nl">NL</option>
            </select>
          </div>
          <div class="col-5 pr-1">
            <input type="text" class="form-control form-control-sm geo-input"
                   :placeholder="$t('Postcode')"
                   name="postCode"
                   v-model="address.postCode"
            >
          </div>
          <div class="col-5">
            <input type="text" class="form-control form-control-sm geo-input"
                   :placeholder="$t('City')"
                   name="cityName"
                   v-model="address.cityName"
            >
          </div>
        </div>
        <input type="hidden" v-model="address.gps.lat">
        <input type="hidden" v-model="address.gps.lon">
      </div>
    </transition>
    <div class="col-md-12" v-show="errorMsg">
      <small class="form-text text-danger">{{ errorMsg }}</small>
    </div>
  </div>
</template>

<script>
  /* ============
   * GeoComplete Component
   * ============
   *
   * Autocomplete with jQuery
   * Need to finish
   */
  import Address from '@/models/Address';
  import { mapGetters } from 'vuex';

  export default {
    name: 'GeoComplete',

    props: {
      placeholder: {
        type: String,
        default: 'Address',
      },
      value: {
        type: Object,
        default() {
          return new Address()
        }
      }
    },

    computed: {
      ...mapGetters('account', ['customerAddresses']),
      hasValidCoordinates() {
        return Number(this.address.gps.lat) && Number(this.address.gps.lon);
      },
      geocodeKeys() {
        return ['']
      },
    },

    data() {
      return {
        loading: false,
        dropdownShown: false,
        address2: {
          addressId: '',
          addressType: '',
          cityName: '',
          countryCode: '',
          countryName: '',
          gps: {lat: 0, lon: 0},
          isPoi: false,
          locationName: '',
          postCode: '',
          streetHouseNumber: '',
          streetHouseNumberAddition: '',
          streetName: "",
          _autocompleteInput: ""
        },
        address: new Address(),
        autocomplete: '',
        showAddressComponents: false,
        showAddressTimeout: null,
        xhrGeocode: null,
        xhrAutocomplete: null,
        errorMsg: '',
        $autocomplete: null,

        xhr: {
          abort:()=>{},
          readyState: 0,
        },
        autocompleteResults: [],
        autocompleteInputValue: '',
      }
    },

    mounted() {
      const self = this;

      this.init();
      this.$log.debug(this.$options.name, this);

      $(this.$refs.addressComponents).on('click', function(){
        self.showAddressComponents = true;
      })

      const $inputs= $(this.$el).find('input, select');

      $inputs
        .on('focusout', function(){
          self.showAddressTimeout= setTimeout(function(){
            self.showAddressComponents= false;
          }, 100);
        }).on('focusin', function(){
        clearTimeout(self.showAddressTimeout);
        self.showAddressComponents = true;
      })
    },

    methods: {
      init() {
        const self= this;
        const _this= $(this.$refs.autocomplete);
        this.$autocomplete = $(this.$refs.autocomplete);
        const _data= {
          results: [],
          address: null,
          ongoingRequest: null,
          componentsGeocodeTimeout: null
        };

        _this.autocomplete({
          delay: 100,
          minLength: 0, // local addresses
          autoFocus: false,
          classes: { 'ui-autocomplete': "street-autocomplete-dropdown" },
          messages : {
            noResults : 'No results found.',
            results : function(count) {
              if( count === 1 ) {
                return self.$t("1 result found")
              }
              return self.$t("Many results found", {count})
              //  return count + (count > 1 ? ' results' : ' result ') + ' found. Choose a suggested option below.';
            }
          },
          source: function(request, response) {
            if( self.xhr ) {
              self.xhr.abort();
            }
            self.autocompleteResults = [];
            // if( _data.ongoingRequest ) {
            //   _data.ongoingRequest.abort()
            // }
            // _data.results= []

            const terms= request.term.split(',').map(word => word.trim());
            const cityName= terms.length > 1 ? _.last(terms) : null;
            const search = _.first(terms);

            // TODO show customer addresses
            // if( search.length < 3 ) {
            //   return response(_.filter(self.customerAllAddresses, addr =>{
            //     return _.toLower(_.join(_.compact([addr.locationName, addr.streetName]), ' ')).includes(_.toLower(search))
            //   }))
            //   // return response([])
            // }
            if(!search) {
              self.resetAddress();
              return response(self.customerAddresses.slice());
            }

            self.xhr = self.makeAjax({
              location: {
                lat: 51.79565298474061,
                lon: 4.6849822998046875
              },
              term: search,
              search,
              cityName,
              countryCode: "nl",
              fallback: false
            }).done(res =>{
              response(res.map(e => new Address(e)));
            }).fail((jqXHR, textStatus, errorThrown)=>{
              response([]);
            });
          },
          // change: function() {
          //   if(_.isEmpty(_data.address) && _this.val() && _data.results && _data.results.length ) {
          //     console.log("Autocomplete input change event, selecting first result")
          //     _this.data('ui-autocomplete')._trigger('select', 'autocompleteselect', {item:_data.results[0]})
          //   }
          // },
          search: function() {
            self.loading= true;
          },
          response: function(e, data) {
            self.loading= false;
            self.autocompleteResults = data.content;
          },
          focus: function(event, {item}) {
            event.preventDefault();
            event.stopPropagation();

            if ( !event.which ) {
              // The Autocomplete behavior shouldn't change
              // the input text on mouseover/hover.
              // It's too obtrusive, so preventing it
              return false;
            }

            const { locationName, streetName, streetHouseNumber, cityName } = item;
            const address = _.compact([
              _.compact([
                locationName,
                _.compact([ streetName, streetHouseNumber ]).join(' '),
              ]).join(', '),
              // add space for house number entering
              !locationName && !streetHouseNumber && ' '
            ]).join('');

            // set result value to input with city
            $(event.target).val(_.compact([ address, cityName ]).join(', '));

            // set focus to right place for house number entering
            if( !locationName ) {
              $(event.target).setCursorPosition(address.length);
            }
            return false;
          },
          select: function(event, {item}) {
            event.preventDefault();
            event.stopPropagation();

            _data.selecting= true

            _data.address= new Address(item);
            self.setAddress(_data.address);
            self.showAddressComponents = !_data.address.streetHouseNumber; //false;

            if( item.addressId ) {
              self.loading = true;
              self.getPlace(item.addressId)
                .done((res)=>{
                  if(res && res[0]) {
                    _data.address= new Address(res[0]);
                    self.setAddress(_data.address);
                  }
                })
                .fail((jqXHR)=>{

                })
                .always(()=>{
                  self.loading = false;
                })
            } else {
              if( !item.locationName ) { // put cursor after house number
                _this.setCursorPosition(_this.val().indexOf(','))
              }
            }
            return false;
          },
          open: function( event, ui ) {
            self.dropdownShown = true;
          },
          close: function (event, ui) {
            self.dropdownShown = false;
            if( typeof window.debugAc !== 'undefined' ) {
              $(_this.data('uiAutocomplete').menu.element).show()
            }
          },
        })
          .on('keyup', function(event){
            if( event.which === 13 ) {
              // select first result with enter without need to focus result in dropdown
              // autoFocus option must be 'false'!!!
              const $menu = _this.data('uiAutocomplete').menu.element;
              if (self.xhr.readyState === 4 && self.autocompleteResults.length
                && $menu.is(':visible') && $menu.find('.ui-state-active').length === 0
              ) {
                self.$emit('input', new Address(self.autocompleteResults[0]));
                _this.autocomplete('close');
              }

            } else if ( event.which === 27 || event.key === 'Escape' ) {
              self.showAddressComponents = !self.showAddressComponents;
              _this.blur()

            } else if( self.isDeleteKey(event) ) {
              self.resetAddress(true);

            } else if(event.code === 'Tab' || event.which === 9) {

            } else if( !_.includes([37,38,39,40], event.which)) {
              // check if input has changed, if so, clear address components
              const val1= _this.val().split(',').map(w => w.trim()).join(', ');
              let val2= _data.address && _data.address.formattedAddress;
              // console.log({val1, val2});
              if( val1 !== val2 ) {
                // console.log("Clearing stored address");
                self.address.gps.lat = 0;
                self.address.gps.lon = 0;
                // self.resetGps()
              } else {
                // console.log("Stored address same as input");
                if(!self.hasValidCoordinates) {
                  // ovo se dogodi kada se otvori ac sa rezultatima
                  // prodes s tipkovnicom po rezultatima ( brisu se komponente )
                  // pa ako stisnes ESC ucita ti zadnju koja je bila spremljena
                  // prije nego si se igrao sa tipkovnicom po rezultatima
                  setAddress(_data.address)
                }
              }
            }
          })
          .on('blur', function() {
            // console.log("Val", _this.val(), "=>", self.address.formattedAddress)
            // const diff = (diffMe, diffBy) => diffMe.split(diffBy).join('')
            // const C = diff(self.address.formattedAddress, _this.val())
            // console.log(C)
          })
          .on('focus', function(){
            if(!_.trim(_this.val())) {
              setTimeout(()=>{
                _this.autocomplete('search', '')
              },350)
            }
          });


        _this.data('ui-autocomplete')._renderItem = function(ul, item) {
          let address= item.formattedAddressHTML;
          $.each(_.compact(_.flatten(this.term.split(' ').map(w => w.split(',')))), function(_, value) {
            const regex= new RegExp("(?![^&;]+;)(?!<[^<>]*)(" + $.ui.autocomplete.escapeRegex(value) + ")(?![^<>]*>)(?![^&;]+;)", "gi");
            address = address.replace(regex, "<strong>$1</strong>");
          });
          return $('<li></li>').data('item.autocomplete', item)
            .append(`<div class="ac-row"><i class="fa fa-${item.isPoi?'star':'map-marker'}"></i> ${address}</div>`)
            .appendTo(ul);
        };

        function setAddress(address) {
          // Vue.set(self.trip[e.parent], e.path, Address(address))
          //console.log("SET ADRESS", address)
          self.$set(self, 'address', {
            ...address,
            formattedAddress: self.formattedAddress(address, true),
            _autocompleteInput: self.formattedAddress(address, true),
          })
          self.showAddressComponents= false;
          setTimeout(()=>{
            $('body').click(); // close address components
          },150)
        }

        $(this.$el).find('.geo-input')
          .on('keyup', function(event){
            if(event.key === 'Enter' || event.which === 13) {
              self.geocodeAddress()
            } else if( self.isDeleteKey(event) ) {
              self.resetAddress(true)
            }
          })
          .on('blur', function(){
            if(!self.hasValidCoordinates) {
              self.geocodeAddress()
            }
          })
          .on('input', function(){
            // console.log("CLEAR COORDS")
            self.$emit('input', new Address({
              ...self.address,
              gps: {lat: 0, lon: 0}
            }))
            // self.setAddress({
            //   ...this.address,
            //   gps: {lat:0, lon:0}
            // });
            clearTimeout(_data.componentsGeocodeTimeout)
            _data.componentsGeocodeTimeout= setTimeout(()=>{
              if(!self.hasValidCoordinates) {
                self.geocodeAddress()
              }
            },850)
          })

      },
      setAddress(address) {
        this.$log.debug('set new address and emit');
        this.$set(this, 'address', new Address(address || {}));
        $(this.$refs.autocomplete).val(this.address.formattedAddress);
        if(!_.isEqual(this.address, this.value)) {
          this.$emit('input', this.address);
        }
      },
      makeAjax(data) {
        return $.ajax({
          type: 'post',
          url: process.env.VUE_APP_API_LOCATION + '/geo/autocomplete',
          contentType: 'application/json',
          dataType: 'json',
          data: JSON.stringify(data),
          headers: {
            Authorization: `Bearer ${localStorage.getItem('id_token')}`
          }
        })
      },
      getPlace(placeId) {
        return $.ajax({
          type: 'post',
          url: process.env.VUE_APP_API_LOCATION + '/geo/place/'+placeId,
          contentType: 'application/json',
          dataType: 'json',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('id_token')}`
          }
        })
      },
      geocodeAddress() {
        const self = this;
        if( this.xhrGeocode ) {
          this.xhrGeocode.abort();
        }
        this.errorMsg = null;

        const address= this.getGeocodeData();
        if(!address) {
          return;
        }

        if(!address.streetName || !address.cityName) {
          return this.errorMsg = "mandatory params missing for geocode";
        }

        this.loading = true;
        this.xhrGeocode= $.ajax({
          type: 'post',
          url: process.env.VUE_APP_API_LOCATION + '/geo/geocode',
          contentType: 'application/json',
          dataType: 'json',
          data: JSON.stringify({address}),
          headers: {
            Authorization: `Bearer ${localStorage.getItem('id_token')}`
          }
        })
          .done((res)=>{
            if(res && res[0]) {
              self.$emit('input', new Address(res[0]));
              self.showAddressComponents = false;
            }
          })
          .fail((jqXHR, extStatus, errorThrown)=>{
            // TODO show error
            self.errorMsg= self.$t('Failed to geocode address')
          })
          .always(()=>{
            self.loading = false;
          })
      },
      getGeocodeData() {
        const address= _.transform(this.address, (acc, val, key)=>{
          if( _.includes([
            'locationName',
            'streetName',
            'streetHouseNumber',
            'streetHouseNumberAddition',
            'postCode',
            'cityName',
            'countryCode',
          ], key)) {
            acc[key]= _.trim(val);
          }
        },{});
        if( _.compact(_.values(_.omit(address, 'countryCode'))).length === 0 ) {
          return null;
        }
        return address;
      },
      formattedAddress(address, stripHTML) {
        const obj= _.isObjectLike(address) ? _.clone(address) : {};
        var street= _.compact([
          obj.streetName,
          obj.streetHouseNumber,
          obj.streetHouseNumberAddition
        ]).join(" ");
        var city= _.compact([
          obj.postCode,
          obj.cityName,
          // obj.countryName
        ]).join(", ");

        if( city ) {
          city= '<span class="city-label">'+city+'</span>';
        }

        if(!street && obj.locationName) {
          return obj.locationName
        } else if( obj.locationName ) {
          street= obj.locationName + ", " + street
        }

        if(obj.favoriteName) {
          street= obj.favoriteName + ", " + street
        }

        let formattedAddress= _.compact([ street, ",", city ])
          .join(" ")
          .replace(/ ,/g, ',')
          .replace(/(^,)|(,$)/g, '')

        if(stripHTML) {
          return $('<p>'+formattedAddress+'</p>').text()
        }
        return formattedAddress;
      },
      resetAddress(focus) {
        this.$emit('input', new Address());
        if( focus ) {
          this.$autocomplete.focus();
        }
      },
      resetGps() {
        this.$emit('input', new Address({
          ...this.address,
          gps: {lat: 0, lon: 0}
        }))
      },
      isDeleteKey(event) {
        return event.code === 'Delete' || event.which === 46;
      }
    },

    watch: {
      value: {
        deep: true,
        handler() {
          this.$log.debug('address value prop changed, set address');
          //this.setAddress(this.value);
          this.$set(this, 'address', new Address(this.value));
          this.autocomplete= this.address.formattedAddress;
        }
      },
      'address.gps'({lat, lon}) {
        if(_.compact(_.values(_.omit(this.address, ['gps']))).length === 0) {
          this.errorMsg = null;
        }
        if(lat && lon) {
          this.errorMsg = null;
        }
      },
    },

    beforeDestroy() {
      $(this.$refs.autocomplete).autocomplete('destroy');
    }
  };
</script>

<style lang="scss"  scoped>
  .address-components {
    .row {
      background: #f1f1f1;
    }
  }
  .loading-gif {
    background: #fff url(../../public/img/loading.gif) no-repeat right center;
  }
</style>
